/* eslint-disable no-underscore-dangle */
/* eslint-disable import/no-unresolved */
/* eslint-disable @typescript-eslint/ban-ts-comment */
const initializeApp = async () => {
  const { default: initializeGlobalVars } = await import(
    '@anova/crude-vars/src/initialize-globals'
  );
  initializeGlobalVars();

  // @ts-ignore
  window.__DOMAIN__ =
    // @ts-ignore
    window['__ANOVA-VARS__'].global.DOMAIN || process.env.REACT_APP_DOMAIN;

  // TODO: TO REMOVE AFTER ALL MODULES USE NEW IMPLEMENTATION
  import('./bootstrap');

  const { default: vars } = await import('@anova/crude-vars');

  // @ts-ignore
  window.__DOMAIN__ = vars.global.DOMAIN || process.env.REACT_APP_DOMAIN;
  // @ts-ignore
  window.MICRO_FRONTEND = true;

  const [renderer, MicroFrontendApp] = await Promise.all([
    // @ts-ignore
    import('base/renderer'),
    import('./App'),
  ]);

  renderer.default(MicroFrontendApp.default);
};

initializeApp();

/**
 * method exported for testing purposes
 */
export const testInit = initializeApp;

export default undefined;
